import eventbus from '../../eventBus';
import { getDateMonthsBefore, getDateDayBefore } from "../../shared/utils";
import * as lang from "vuejs-datepicker/src/locale";
import moment from 'moment';
export default {
    inject: ['$validator'],
    data() {
      return {
        loading: false,
        request: {            
            startDate: getDateDayBefore(new Date(), 7),
            startHour: '00:00:00',
            endDate: new Date(),
            endHour: '23:59:59',
            hasInstallments: '',
            origin: '',
            seller: '',
            device: '',
            salesPerson: '',
            paymentMethod: null,
            paymentMethodType: null,
            isVoucherOnly: false,
        },
        result: this.getEmptyResult(),      
        fields: [
            { key: "serialNumber", label: "Referência", sortable: false },
            { key: "date", label: "Data Liberação", sortable: false },
            { key: "sellerName", label: "Empresa", sortable: false },
            { key: "paymentMethodFormatted", label: "Tipo", sortable: false },
            { key: "cardNumber", label: "Card Holder", sortable: false },            
            { key: "grossAmount", label: "Valor Bruto", sortable: false },
            { key: "netAmount", label: "Valor Liquido", sortable: false }            
        ],
        languages: lang,
        zeroAsString: (0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      }
    },
    mounted() {
        const self = this;
        eventbus.$on(`transactions-filter:search`, function() {
            self.search();
        });
    },
    methods: {
        search() {
            this.fetchData(1);
            this.fetchSummaryData();
            this.fetchBalanceSummary();
        },
        getEmptyResult() {
            return {
                pageIndex: 1,
                pageSize: 0,
                rowCount: 0,
                data: []
            };
        },
        getRequestParams() {
            return {
                partnerId: this.$auth.partnerKey,
                sellerId: this.request.seller == null || this.request.seller == '' ? '' : this.request.seller,
                deviceId: this.request.device == null || this.request.device == '' ? '' : this.request.device,
                salesPersonId: this.request.salesPerson == null || this.request.salesPerson == '' ? '' : this.request.salesPerson,
                paymentMethodTypeId: this.request.paymentMethodType == null ? '' : this.request.paymentMethodType,
                paymentMethodId: this.request.paymentMethod == null ? '' : this.request.paymentMethod,
                startDate: this.formatDate(this.request.startDate, this.request.startHour),
                endDate: this.formatDate(this.request.endDate, this.request.endHour),
                hasInstallments: this.request.hasInstallments,
                origin: this.request.origin
            }
        },
        formatDate(date, hour) {
            let d = moment(date).format('YYYY-MM-DD');
            let f = moment(`${d} ${hour}`).toDate();
            return f;
        },
        onPageIndexChanged(p, tableName) {
            this.fetchData(p);
            this.fetchBalanceSummary();
        },
        fetchBalanceSummary(){
            eventbus.$emit(`balance-summary:refresh`);
        },
        showLoading() {
            this.loading = true;
            eventbus.$emit("ui-action:loading", true);
        },
        hideLoading() {
            this.loading = false;
            eventbus.$emit("ui-action:loading", false);
        }, 
    }
}